import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class TargetSourceAttributeFilterData {
    targetObjectAttributes: Array<DropdownOptionIntegerId>;
    sourceObjectAttributes: Array<DropdownOptionIntegerId>;
    targetObjects: Array<DropdownOptionIntegerId>;
    sourceObjects: Array<DropdownOptionIntegerId>;
}